(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('product-breadcrumb-scroll')) {
    customElements.define('product-breadcrumb-scroll', class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('pointerdown', (event) => {
          this.dragged = false;
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.scrollWidth <= this.clientWidth) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.scrollLeft };
        });
        this.addEventListener('pointermove', (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const distance = event.clientX - this.drag.x;
          if (!this.dragged && Math.abs(distance) < 6) return;
          if (!this.dragged) {
            this.dragged = true;
            this.setPointerCapture(event.pointerId);
            this.classList.add('is-dragging');
          }
          event.preventDefault();
          this.scrollLeft = this.drag.scroll - distance;
        });
        const endDrag = (event) => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.drag = null;
          this.classList.remove('is-dragging');
          if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        };
        this.addEventListener('pointerup', endDrag);
        this.addEventListener('pointercancel', endDrag);
        this.addEventListener('lostpointercapture', endDrag);
        this.addEventListener('pointerleave', (event) => {
          if (!this.dragged) endDrag(event);
        });
        this.addEventListener('dragstart', (event) => {
          if (this.drag) event.preventDefault();
        });
        this.addEventListener('click', (event) => {
          if (this.dragged && event.detail !== 0) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
